var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAction01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#7a934f",
    d: "M0 4c0-.53.184-1.04.513-1.414A1.647 1.647 0 0 1 1.75 2h10.5c.464 0 .91.21 1.237.586C13.816 2.96 14 3.47 14 4v1H0zm14 3v5c0 .53-.184 1.04-.513 1.414A1.647 1.647 0 0 1 12.25 14H1.75c-.464 0-.91-.21-1.237-.586A2.154 2.154 0 0 1 0 12V7zM2.625 9a.824.824 0 0 0-.619.293A1.077 1.077 0 0 0 1.75 10v1c0 .265.092.52.256.707a.824.824 0 0 0 .619.293H3.5a.824.824 0 0 0 .619-.293c.164-.187.256-.442.256-.707v-1c0-.265-.092-.52-.256-.707A.824.824 0 0 0 3.5 9z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAction01);
export default __webpack_public_path__ + "static/media/action01.b73c79c6934335a393f1cc05ca35f0b4.svg";
export { ForwardRef as ReactComponent };